import { IconButton, useColorModeValue } from "@chakra-ui/react";
import GlobeIcon from "./GlobeIcon";

export default function GlobeButton({ showMap, setShowMap }) {
  const iconColor = useColorModeValue("#4b635e", "#E9A6A6");
  const icon = <GlobeIcon color={iconColor} width="80%" />;

  return (
    <IconButton
      aria-label="Show Map"
      icon={icon}
      onClick={() => setShowMap(!showMap)}
      size="md"
      boxShadow="lg"
    />
  );
}
